var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('button',{staticClass:"back-to-top",attrs:{"title":"Retour en haut"},on:{"click":_vm.scrollTop}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(" mdi-arrow-up ")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }